import { ArrowDownIcon } from 'assets/icons/arrow-down';
import React from 'react';
import { Link } from 'react-router';
import { cn } from 'utils';

interface SidebarSubItemProps {
  title: string;
  href: string;
  isExpanded: boolean;
  isActive: boolean;
  hasSubItems?: boolean;
  onToggle?: () => void;
  onClick?: () => void;
}

const SidebarSubItem: React.FC<SidebarSubItemProps> = ({
  title,
  href,
  isExpanded,
  isActive,
  hasSubItems,
  onToggle,
  onClick,
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between py-2 cursor-pointer',
        isActive && 'text-blue-600 font-medium'
      )}
      onClick={onToggle}
    >
      <Link
        to={href}
        className="flex-1 text-[12px]"
        onClick={(e) => {
          if (hasSubItems) {
            e.preventDefault();
          } else {
            onClick?.();
          }
        }}
      >
        {title}
      </Link>

      {hasSubItems && (
        <div
          className={cn(
            'transition-transform mr-4',
            isExpanded ? 'rotate-180' : 'rotate-0'
          )}
        >
          <ArrowDownIcon />
        </div>
      )}
    </div>
  );
};

export default SidebarSubItem;
